import React, { forwardRef } from 'react'

import { ProgressIndicatorSpinnerIcon } from '@hm-group/fabric-icons/icons/ProgressIndicatorSpinnerIcon'
import cn from 'classnames'
import { Transition } from 'react-transition-group'

import styles from './Spinner.module.scss'
import { SpinnerProps } from './types'

const Spinner: React.FC<SpinnerProps> = forwardRef(
  ({ isRendered = true, className, size = 'medium', testId }, ref) => (
    <Transition
      in={isRendered}
      timeout={{ enter: 0, exit: 300 }}
      mountOnEnter
      unmountOnExit
      nodeRef={ref}
    >
      {(transitionState) => (
        <span
          role="progressbar"
          className={cn(
            styles.container,
            transitionState && styles[`container_${transitionState}`],
            className,
          )}
        >
          <ProgressIndicatorSpinnerIcon className={styles.icon} size={size} data-testid={testId} />
        </span>
      )}
    </Transition>
  ),
)

export default Spinner
